import type { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface TruncatedTooltipProps {
  text: string;
  children?: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function TruncatedTooltip({
  text,
  children,
  className,
  contentClassName,
}: TruncatedTooltipProps) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn('block min-w-0 truncate', className)}>{children ?? text}</span>
        </TooltipTrigger>
        <TooltipContent
          className={cn('max-w-sm break-words text-left leading-snug', contentClassName)}
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
